/* eslint-disable react/prop-types */
import React from 'react'
import './profileLoggedIn.scss'

import userLogo from '../../assets/user_logo.svg'
import ButtonText from "../buttonText/buttonText";
import AvaliationStar from "../avaliationStars/avaliationStars"
import { AllAnunciosChip } from '../../queries/anuncios'
import { RateRankClient, RateRankPro } from '../../queries/rank'
import { Query } from "react-apollo"
import { ProposePro, ProposeCli } from "../../queries/propose"
import { Link, NavLink } from 'react-router-dom'
import Simplert from 'react-simplert'
import ErrorBroundray from '../../components/errorBoundary/errorBoundary'



export default class ProfileLoggedIn extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showAlert: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot',
            loading: false,
            onClose: null,
        }

    }


    render() {
        const { userInfo } = this.props;

        return (
            <div className={'ProfileLoggedIn col-xs-12'}>
                <Simplert
                    showSimplert={this.state.showAlert}
                    type={this.state.typeAlert}
                    title={this.state.titleAlert}
                    message={this.state.messageAlert}
                    customCloseBtnText={this.state.customCloseBtnText}
                    customCloseBtnClass={this.state.customCloseBtnClass}
                    onClose={this.state.onClose}
                />
                <div className="row center-xs">
                    <div className={'userInfo col-xs-12'}>
                        <div className={'user row middle-xs center-xs'}>
                            <div className='imgprofile col-xs-4 col-sm-3'>
                                <img src={userInfo.photo ? userInfo.photo : userLogo} alt={userInfo.name} />
                                {/*{this.state.loading ? <Loading /> : <input id="buttonUploadImg" label='Alterar imagem de perfil' type='file' accept='image/*' onChange={this.onSelectFile} />}*/}
                                <Link to="/perfil/data"><ButtonText name={'editar perfil'} /></Link>
                            </div>
                            <div className='dataprofile col-xs-8 col-sm-7'>
                                <h1>{userInfo.name ? userInfo.name : 'Nome Usuário'}</h1>
                                <span>{userInfo.address.state ? userInfo.address.city + ' - ' + userInfo.address.state : ''}</span>

                                <ErrorBroundray><Query query={AllAnunciosChip} variables={{ userId: userInfo.id }}>
                                    {res => {
                                        if (res.error) throw new Error(res.error.message)
                                        return res.data ?
                                            res.data.allAnuncios && res.data.allAnuncios.length ?
                                                res.data.allAnuncios.map((p, i) => (
                                                    p.active ? <span className="skills" key={i}>{p.skill.name}</span> : null)) : null
                                            : null
                                    }}
                                </Query>
                                </ErrorBroundray>
                            </div>
                            <div className={'moneyInfo col-xs-12 col-sm-2'}>
                                <ErrorBroundray><div className={'enter'}>
                                    <span>Recebido </span>
                                    <Query query={ProposePro} variables={{ id: userInfo.id }}>
                                        {res => {
                                            if (res.error) throw new Error(res.error.message)
                                            if (res.data.user && res.data.user.proposes.length) {
                                                const propostas = res.data.user.proposes

                                                let count = 0

                                                propostas.map(prop => (
                                                    prop.valueEnd && prop.status === "Finalizada" ?
                                                        (count = parseFloat(count) + parseFloat(prop.valueEnd)) : null
                                                ))

                                                return <span><strong>R$ {count === 0 ? "0,00" : count}</strong></span>
                                            } else {
                                                return <span><strong>R$ 0,00</strong></span>
                                            }
                                        }}
                                    </Query>
                                </div></ErrorBroundray>
                                <ErrorBroundray><div className={'spend'}>
                                    <span>Gasto </span>
                                    <Query query={ProposeCli} variables={{ id: userInfo.id }}>
                                        {res => {
                                            if (res.error) throw new Error(res.error.message)
                                            if (res.data.user && res.data.user.proposesFrom.length) {
                                                const propostas = res.data.user.proposesFrom

                                                let count = 0

                                                propostas.map(prop => (
                                                    prop.valueEnd && typeof prop.valueEnd !== "string" && prop.valueEnd !== null ?
                                                        (count = parseFloat(count) + parseFloat(prop.valueEnd)) : null
                                                ))

                                                return <span><strong>R$ {count === 0 ? "0,00" : count}</strong></span>
                                            } else {
                                                return <span><strong>R$ 0,00</strong></span>
                                            }
                                        }}
                                    </Query>
                                </div></ErrorBroundray>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'userAction row center-xs'}>
                    <div className={'userNotes col-xs-12 col-sm-4 last-sm start-lg'}>
                        <div className="row center-xs">
                            <Link to={'/perfil/rank'}>
                                <div className="col-xs-6">
                                    <span>Cliente</span>
                                    <Query query={RateRankClient} variables={{ userId: userInfo.id }}>
                                        {res => {
                                            if (res.error) throw new Error(res.error.message)
                                            let notes = []
                                            let clientRate = 0
                                            if (res.data.allRanks) {
                                                res.data.allRanks.map(rank => (
                                                    notes.push(rank.media)
                                                ))
                                                clientRate = notes.length ? parseInt(notes.reduce((sum, num) => sum + num) / notes.length) : 0
                                            }

                                            return <AvaliationStar avaliation={clientRate ? clientRate : 0} />
                                        }}
                                    </Query>
                                </div>
                                <div className="col-xs-6">
                                    <span>Profissional</span>
                                    <Query query={RateRankPro} variables={{ userId: userInfo.id }}>
                                        {res => {
                                            if (res.error) throw new Error(res.error.message)
                                            let notes = []
                                            let proRate = 0
                                            if (res.data.allRanks) {
                                                res.data.allRanks.map(rank => (
                                                    notes.push(rank.media)
                                                ))
                                                proRate = notes.length ? parseInt(notes.reduce((sum, num) => sum + num) / notes.length) : 0
                                            }

                                            return <AvaliationStar avaliation={proRate ? proRate : 0} />
                                        }}
                                    </Query>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={'menu col-xs-12 col-sm-8 row first-sm center-xs'}>
                        <NavLink exact to="/perfil" activeClassName='active'>
                            <button>
                                <img src="" alt="" />
                                <span>Atividades</span>
                            </button>
                        </NavLink>
                        {userInfo.type === "PROFISSIONAL" ?
                            <NavLink exact to="/perfil/received" activeClassName='active'>
                                <button>
                                    <img src="" alt="" />
                                    <span>Solicitações Recebidas</span>
                                </button>
                            </NavLink> : null}
                        <NavLink exact to="/perfil/send" activeClassName='active'>
                            <button>
                                <img src="" alt="" />
                                <span>Solicitações Enviadas</span>
                            </button>
                        </NavLink>
                        <NavLink exact to="/perfil/meuanuncios" activeClassName='active'>
                            <button>
                                <img src="" alt="" />
                                <span>Meus Anúncios</span>
                            </button>
                        </NavLink>
                    </div>
                </div>
            </div>
        )
    }
}
